import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Alert,
  Container,
  IconButton,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DeleteIcon from '@mui/icons-material/Delete';
import { markAsRead, deleteNotification } from '../../redux/reducers/notificationReducer';
import { useDispatch, useSelector } from 'react-redux';

const NotificationDetail = () => {
  const theme = useSelector((state) => state.themeValue.colors);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { state } = useLocation(); 
  const { notificationId, notifications } = state || {};

  useEffect(() => {
    if (notificationId) dispatch(markAsRead(notificationId));
  }, [notificationId, dispatch]);

  const handleDelete = () => {
    if (notificationId) {
      dispatch(deleteNotification(notificationId));
      navigate(-1); // Go back after deleting
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  if (!notifications) {
    return (
      <Container maxWidth="sm">
        <Box mt={4}>
          <Alert severity="error">Notification not found.</Alert>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm" sx={{minHeight:"100vh"}}>
      {/* Header with Back and Delete */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mt={4}
        mb={2}
      >
        <IconButton onClick={handleBack} sx={{ color: theme.text }}>
          <ArrowBackIcon />
        </IconButton>
        <IconButton onClick={handleDelete} sx={{ color: 'red' }}>
          <DeleteIcon />
        </IconButton>
      </Box>

      {/* Notification Card */}
      <Card sx={{ padding: 2, backgroundColor: theme.background }}>
        <CardContent>
          <Typography variant="h5" gutterBottom sx={{ color: theme.text }}>
            {notifications?.title}
          </Typography>
          <Typography variant="body1" paragraph sx={{ color: theme.text }}>
            {notifications?.comments || "No additional details provided."}
          </Typography>
          <Typography variant="caption" sx={{ color: theme.text }}>
            {new Date(notifications?.created_at).toLocaleString()}
          </Typography>
        </CardContent>
      </Card>
    </Container>
  );
};

export default NotificationDetail;
